import script from "./ReturnViewPdf.vue?vue&type=script&lang=js"
export * from "./ReturnViewPdf.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__